export const graphList = [
  {
    nodes: {
      0: {
        x: 435,
        y: 64,
      },
      1: {
        x: 338,
        y: 158,
      },
      2: {
        x: 436,
        y: 159,
      },
      3: {
        x: 567,
        y: 164,
      },
      4: {
        x: 240,
        y: 282,
      },
      5: {
        x: 337,
        y: 277,
      },
      6: {
        x: 574,
        y: 265,
      },
      7: {
        x: 701,
        y: 271,
      },
      8: {
        x: 156,
        y: 415,
      },
      9: {
        x: 239,
        y: 416,
      },
      10: {
        x: 577,
        y: 404,
      },
      11: {
        x: 676,
        y: 401,
      },
    },
    topNode: 13,
    topEdge: 11,
    isWeighted: false,
    isDirected: false,
    edges: {
      0: {
        u: '0',
        v: '1',
        w: 1,
      },
      1: {
        u: '0',
        v: '2',
        w: 1,
      },
      2: {
        u: '0',
        v: '3',
        w: 1,
      },
      3: {
        u: '1',
        v: '4',
        w: 1,
      },
      4: {
        u: '1',
        v: '5',
        w: 1,
      },
      5: {
        u: '4',
        v: '8',
        w: 1,
      },
      6: {
        u: '4',
        v: '9',
        w: 1,
      },
      7: {
        u: '3',
        v: '6',
        w: 1,
      },
      8: {
        u: '3',
        v: '7',
        w: 1,
      },
      9: {
        u: '6',
        v: '10',
        w: 1,
      },
      10: {
        u: '6',
        v: '11',
        w: 1,
      },
    },
  },
  {
    nodes: {
      0: {
        x: 435,
        y: 64,
      },
      1: {
        x: 338,
        y: 158,
      },
      2: {
        x: 436,
        y: 159,
      },
      3: {
        x: 567,
        y: 164,
      },
      4: {
        x: 240,
        y: 282,
      },
      5: {
        x: 337,
        y: 277,
      },
      6: {
        x: 574,
        y: 265,
      },
      7: {
        x: 701,
        y: 271,
      },
      8: {
        x: 156,
        y: 415,
      },
      9: {
        x: 239,
        y: 416,
      },
      10: {
        x: 577,
        y: 404,
      },
      11: {
        x: 676,
        y: 401,
      },
    },
    topNode: 13,
    topEdge: 11,
    isWeighted: false,
    isDirected: true,
    edges: {
      0: {
        u: '0',
        v: '1',
        w: 1,
      },
      1: {
        u: '0',
        v: '2',
        w: 1,
      },
      2: {
        u: '0',
        v: '3',
        w: 1,
      },
      3: {
        u: '1',
        v: '4',
        w: 1,
      },
      4: {
        u: '1',
        v: '5',
        w: 1,
      },
      5: {
        u: '4',
        v: '8',
        w: 1,
      },
      6: {
        u: '4',
        v: '9',
        w: 1,
      },
      7: {
        u: '3',
        v: '6',
        w: 1,
      },
      8: {
        u: '3',
        v: '7',
        w: 1,
      },
      9: {
        u: '6',
        v: '10',
        w: 1,
      },
      10: {
        u: '6',
        v: '11',
        w: 1,
      },
    },
  },
  {
    topNode: 25,
    topEdge: 48,
    isWeighted: false,
    isDirected: false,
    nodes: {
      0: {
        x: 433,
        y: 259,
      },
      1: {
        x: 432,
        y: 171,
      },
      2: {
        x: 501,
        y: 189,
      },
      3: {
        x: 517,
        y: 259,
      },
      4: {
        x: 506,
        y: 322,
      },
      5: {
        x: 435,
        y: 333,
      },
      6: {
        x: 365,
        y: 332,
      },
      7: {
        x: 350,
        y: 258,
      },
      8: {
        x: 358,
        y: 194,
      },
      9: {
        x: 433,
        y: 99,
      },
      10: {
        x: 569,
        y: 138,
      },
      11: {
        x: 589,
        y: 261,
      },
      12: {
        x: 573,
        y: 370,
      },
      13: {
        x: 435,
        y: 404,
      },
      14: {
        x: 311,
        y: 380,
      },
      15: {
        x: 274,
        y: 258,
      },
      16: {
        x: 297,
        y: 129,
      },
      17: {
        x: 432,
        y: 29,
      },
      18: {
        x: 630,
        y: 80,
      },
      19: {
        x: 671,
        y: 263,
      },
      20: {
        x: 633,
        y: 430,
      },
      21: {
        x: 432,
        y: 465,
      },
      22: {
        x: 261,
        y: 427,
      },
      23: {
        x: 204,
        y: 256,
      },
      24: {
        x: 236,
        y: 72,
      },
    },
    edges: {
      24: {
        u: '0',
        v: '1',
        w: 1,
      },
      25: {
        u: '0',
        v: '2',
        w: 1,
      },
      26: {
        u: '0',
        v: '3',
        w: 1,
      },
      27: {
        u: '0',
        v: '4',
        w: 1,
      },
      28: {
        u: '0',
        v: '5',
        w: 1,
      },
      29: {
        u: '0',
        v: '6',
        w: 1,
      },
      30: {
        u: '0',
        v: '7',
        w: 1,
      },
      31: {
        u: '0',
        v: '8',
        w: 1,
      },
      32: {
        u: '1',
        v: '9',
        w: 1,
      },
      33: {
        u: '2',
        v: '10',
        w: 1,
      },
      34: {
        u: '3',
        v: '11',
        w: 1,
      },
      35: {
        u: '4',
        v: '12',
        w: 1,
      },
      36: {
        u: '5',
        v: '13',
        w: 1,
      },
      37: {
        u: '6',
        v: '14',
        w: 1,
      },
      38: {
        u: '7',
        v: '15',
        w: 1,
      },
      39: {
        u: '8',
        v: '16',
        w: 1,
      },
      40: {
        u: '9',
        v: '17',
        w: 1,
      },
      41: {
        u: '10',
        v: '18',
        w: 1,
      },
      42: {
        u: '11',
        v: '19',
        w: 1,
      },
      43: {
        u: '12',
        v: '20',
        w: 1,
      },
      44: {
        u: '13',
        v: '21',
        w: 1,
      },
      45: {
        u: '14',
        v: '22',
        w: 1,
      },
      46: {
        u: '15',
        v: '23',
        w: 1,
      },
      47: {
        u: '16',
        v: '24',
        w: 1,
      },
    },
  },
  {
    edges: {
      0: {
        u: '0',
        v: '1',
        w: 1,
      },
      1: {
        u: '1',
        v: '2',
        w: 1,
      },
      2: {
        u: '2',
        v: '3',
        w: 1,
      },
      3: {
        u: '3',
        v: '4',
        w: 1,
      },
      5: {
        u: '4',
        v: '5',
        w: 1,
      },
      6: {
        u: '5',
        v: '0',
        w: 1,
      },
      7: {
        u: '0',
        v: '6',
        w: 1,
      },
      8: {
        u: '6',
        v: '7',
        w: 1,
      },
      9: {
        u: '7',
        v: '8',
        w: 1,
      },
      10: {
        u: '8',
        v: '9',
        w: 1,
      },
      11: {
        u: '9',
        v: '10',
        w: 1,
      },
      12: {
        u: '10',
        v: '0',
        w: 1,
      },
    },
    topNode: 11,
    topEdge: 13,
    isWeighted: false,
    isDirected: true,
    nodes: {
      0: {
        x: 437,
        y: 278,
      },
      1: {
        x: 558,
        y: 190,
      },
      2: {
        x: 654,
        y: 192,
      },
      3: {
        x: 756,
        y: 270,
      },
      4: {
        x: 671,
        y: 370,
      },
      5: {
        x: 550,
        y: 371,
      },
      6: {
        x: 321,
        y: 192,
      },
      7: {
        x: 210,
        y: 190,
      },
      8: {
        x: 125,
        y: 262,
      },
      9: {
        x: 194,
        y: 359,
      },
      10: {
        x: 311,
        y: 362,
      },
    },
  },
  {
    topNode: 17,
    topEdge: 16,
    isWeighted: false,
    isDirected: true,
    nodes: {
      0: {
        x: 452,
        y: 40,
      },
      1: {
        x: 261,
        y: 133,
      },
      2: {
        x: 127,
        y: 197,
      },
      3: {
        x: 358,
        y: 227,
      },
      4: {
        x: 264,
        y: 303,
      },
      5: {
        x: 453,
        y: 300,
      },
      6: {
        x: 116,
        y: 401,
      },
      7: {
        x: 257,
        y: 407,
      },
      8: {
        x: 353,
        y: 406,
      },
      9: {
        x: 450,
        y: 421,
      },
      10: {
        x: 550,
        y: 416,
      },
      11: {
        x: 671,
        y: 131,
      },
      12: {
        x: 602,
        y: 218,
      },
      13: {
        x: 754,
        y: 208,
      },
      14: {
        x: 679,
        y: 329,
      },
      15: {
        x: 808,
        y: 329,
      },
      16: {
        x: 843,
        y: 453,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: 1,
      },
      1: {
        u: '1',
        v: '2',
        w: 1,
      },
      2: {
        u: '1',
        v: '3',
        w: 1,
      },
      3: {
        u: '3',
        v: '4',
        w: 1,
      },
      4: {
        u: '4',
        v: '6',
        w: 1,
      },
      5: {
        u: '4',
        v: '7',
        w: 1,
      },
      6: {
        u: '4',
        v: '8',
        w: 1,
      },
      7: {
        u: '3',
        v: '5',
        w: 1,
      },
      8: {
        u: '5',
        v: '9',
        w: 1,
      },
      9: {
        u: '5',
        v: '10',
        w: 1,
      },
      10: {
        u: '0',
        v: '11',
        w: 1,
      },
      11: {
        u: '11',
        v: '12',
        w: 1,
      },
      12: {
        u: '11',
        v: '13',
        w: 1,
      },
      13: {
        u: '13',
        v: '14',
        w: 1,
      },
      14: {
        u: '13',
        v: '15',
        w: 1,
      },
      15: {
        u: '15',
        v: '16',
        w: 1,
      },
    },
  },
  {
    topNode: 17,
    topEdge: 16,
    isWeighted: false,
    isDirected: false,
    nodes: {
      0: {
        x: 48,
        y: 253,
      },
      1: {
        x: 178,
        y: 84,
      },
      2: {
        x: 174,
        y: 215,
      },
      3: {
        x: 167,
        y: 327,
      },
      4: {
        x: 165,
        y: 434,
      },
      5: {
        x: 328,
        y: 85,
      },
      6: {
        x: 328,
        y: 220,
      },
      7: {
        x: 327,
        y: 327,
      },
      8: {
        x: 319,
        y: 432,
      },
      9: {
        x: 504,
        y: 82,
      },
      10: {
        x: 500,
        y: 215,
      },
      11: {
        x: 514,
        y: 326,
      },
      12: {
        x: 509,
        y: 432,
      },
      13: {
        x: 710,
        y: 78,
      },
      14: {
        x: 697,
        y: 208,
      },
      15: {
        x: 714,
        y: 324,
      },
      16: {
        x: 702,
        y: 436,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '1',
      },
      1: {
        u: '1',
        v: '5',
        w: '1',
      },
      2: {
        u: '5',
        v: '9',
        w: '1',
      },
      3: {
        u: '9',
        v: '13',
        w: '1',
      },
      4: {
        u: '0',
        v: '2',
        w: '1',
      },
      5: {
        u: '2',
        v: '6',
        w: '1',
      },
      6: {
        u: '6',
        v: '10',
        w: '1',
      },
      7: {
        u: '10',
        v: '14',
        w: '1',
      },
      8: {
        u: '0',
        v: '3',
        w: '1',
      },
      9: {
        u: '3',
        v: '7',
        w: '1',
      },
      10: {
        u: '7',
        v: '11',
        w: '1',
      },
      11: {
        u: '11',
        v: '15',
        w: '1',
      },
      12: {
        u: '0',
        v: '4',
        w: '1',
      },
      13: {
        u: '4',
        v: '8',
        w: '1',
      },
      14: {
        u: '8',
        v: '12',
        w: '1',
      },
      15: {
        u: '12',
        v: '16',
        w: '1',
      },
    },
  },
  {
    edges: {
      0: {
        u: '0',
        v: '2',
        w: '1',
      },
      1: {
        u: '2',
        v: '7',
        w: '1',
      },
      2: {
        u: '7',
        v: '10',
        w: '1',
      },
      3: {
        u: '10',
        v: '15',
        w: '1',
      },
      4: {
        u: '15',
        v: '17',
        w: '1',
      },
      5: {
        u: '17',
        v: '23',
        w: '1',
      },
      11: {
        u: '0',
        v: '1',
        w: '1',
      },
      12: {
        u: '1',
        v: '7',
        w: '1',
      },
      13: {
        u: '1',
        v: '5',
        w: '1',
      },
      14: {
        u: '5',
        v: '10',
        w: '1',
      },
      15: {
        u: '10',
        v: '13',
        w: '1',
      },
      16: {
        u: '13',
        v: '18',
        w: '1',
      },
      17: {
        u: '18',
        v: '21',
        w: '1',
      },
      22: {
        u: '3',
        v: '7',
        w: '1',
      },
      24: {
        u: '11',
        v: '14',
        w: '1',
      },
      25: {
        u: '14',
        v: '19',
        w: '1',
      },
      26: {
        u: '11',
        v: '16',
        w: '1',
      },
      27: {
        u: '16',
        v: '20',
        w: '1',
      },
      28: {
        u: '20',
        v: '23',
        w: '1',
      },
      29: {
        u: '19',
        v: '22',
        w: '1',
      },
      30: {
        u: '18',
        v: '22',
        w: '1',
      },
      31: {
        u: '16',
        v: '19',
        w: '1',
      },
      35: {
        u: '0',
        v: '3',
        w: '1',
      },
      36: {
        u: '0',
        v: '4',
        w: '1',
      },
      37: {
        u: '4',
        v: '7',
        w: '1',
      },
      39: {
        u: '12',
        v: '16',
        w: '1',
      },
      40: {
        u: '6',
        v: '9',
        w: '1',
      },
      41: {
        u: '2',
        v: '6',
        w: '1',
      },
      42: {
        u: '4',
        v: '8',
        w: '1',
      },
      43: {
        u: '7',
        v: '11',
        w: '1',
      },
      44: {
        u: '8',
        v: '12',
        w: '1',
      },
      45: {
        u: '8',
        v: '11',
        w: '1',
      },
      46: {
        u: '9',
        v: '14',
        w: 1,
      },
      47: {
        u: '15',
        v: '19',
        w: 1,
      },
    },
    topNode: 25,
    topEdge: 48,
    isWeighted: false,
    isDirected: true,
    nodes: {
      0: {
        x: 35,
        y: 244,
      },
      1: {
        x: 100,
        y: 68,
      },
      2: {
        x: 92,
        y: 185,
      },
      3: {
        x: 95,
        y: 297,
      },
      4: {
        x: 95,
        y: 425,
      },
      5: {
        x: 231,
        y: 57,
      },
      6: {
        x: 229,
        y: 160,
      },
      7: {
        x: 219,
        y: 284,
      },
      8: {
        x: 229,
        y: 424,
      },
      9: {
        x: 384,
        y: 57,
      },
      10: {
        x: 379,
        y: 161,
      },
      11: {
        x: 383,
        y: 285,
      },
      12: {
        x: 373,
        y: 445,
      },
      13: {
        x: 532,
        y: 48,
      },
      14: {
        x: 517,
        y: 152,
      },
      15: {
        x: 508,
        y: 246,
      },
      16: {
        x: 507,
        y: 406,
      },
      17: {
        x: 666,
        y: 70,
      },
      18: {
        x: 667,
        y: 207,
      },
      19: {
        x: 660,
        y: 358,
      },
      20: {
        x: 663,
        y: 475,
      },
      21: {
        x: 837,
        y: 81,
      },
      22: {
        x: 846,
        y: 241,
      },
      23: {
        x: 834,
        y: 397,
      },
    },
  },
  {
    nodes: {
      0: {
        x: 86,
        y: 339,
      },
      1: {
        x: 178,
        y: 151,
      },
      2: {
        x: 234,
        y: 389,
      },
      3: {
        x: 306,
        y: 229,
      },
      4: {
        x: 360,
        y: 72,
      },
      5: {
        x: 502,
        y: 166,
      },
      6: {
        x: 672,
        y: 53,
      },
      7: {
        x: 681,
        y: 244,
      },
      8: {
        x: 813,
        y: 180,
      },
      9: {
        x: 788,
        y: 351,
      },
      10: {
        x: 494,
        y: 285,
      },
      11: {
        x: 618,
        y: 386,
      },
      12: {
        x: 432,
        y: 409,
      },
    },
    topNode: 18,
    topEdge: 18,
    isWeighted: false,
    isDirected: true,
    edges: {
      0: {
        u: '0',
        v: '1',
        w: 1,
      },
      1: {
        u: '0',
        v: '2',
        w: 1,
      },
      2: {
        u: '2',
        v: '3',
        w: 1,
      },
      3: {
        u: '1',
        v: '3',
        w: 1,
      },
      4: {
        u: '4',
        v: '1',
        w: 1,
      },
      5: {
        u: '4',
        v: '3',
        w: 1,
      },
      6: {
        u: '4',
        v: '5',
        w: 1,
      },
      7: {
        u: '5',
        v: '6',
        w: 1,
      },
      8: {
        u: '5',
        v: '7',
        w: 1,
      },
      9: {
        u: '6',
        v: '7',
        w: 1,
      },
      10: {
        u: '3',
        v: '10',
        w: 1,
      },
      11: {
        u: '10',
        v: '7',
        w: 1,
      },
      12: {
        u: '3',
        v: '12',
        w: 1,
      },
      13: {
        u: '12',
        v: '11',
        w: 1,
      },
      14: {
        u: '10',
        v: '11',
        w: 1,
      },
      15: {
        u: '11',
        v: '9',
        w: 1,
      },
      16: {
        u: '7',
        v: '9',
        w: 1,
      },
      17: {
        u: '7',
        v: '8',
        w: 1,
      },
    },
  },
  {
    topNode: 6,
    topEdge: 8,
    isWeighted: true,
    isDirected: false,
    nodes: {
      0: {
        x: 148,
        y: 253,
      },
      1: {
        x: 321,
        y: 115,
      },
      2: {
        x: 324,
        y: 413,
      },
      3: {
        x: 627,
        y: 111,
      },
      4: {
        x: 634,
        y: 413,
      },
      5: {
        x: 791,
        y: 255,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '4',
      },
      1: {
        u: '0',
        v: '2',
        w: '2',
      },
      2: {
        u: '2',
        v: '1',
        w: '1',
      },
      3: {
        u: '1',
        v: '3',
        w: '5',
      },
      4: {
        u: '3',
        v: '4',
        w: '2',
      },
      5: {
        u: '4',
        v: '5',
        w: '2',
      },
      6: {
        u: '5',
        v: '3',
        w: '6',
      },
      7: {
        u: '2',
        v: '4',
        w: '10',
      },
    },
  },
  {
    topNode: 6,
    topEdge: 9,
    isWeighted: true,
    isDirected: false,
    nodes: {
      0: { x: 332, y: 369 },
      1: { x: 328, y: 147 },
      2: { x: 504, y: 244 },
      3: { x: 550, y: 416 },
      4: { x: 765, y: 167 },
      5: { x: 576, y: 60 },
    },
    edges: {
      0: { u: '0', v: '1', w: '14' },
      1: { u: '1', v: '5', w: '9' },
      2: { u: '2', v: '1', w: '2' },
      3: { u: '2', v: '0', w: '9' },
      4: { u: '2', v: '3', w: '10' },
      5: { u: '0', v: '3', w: '7' },
      6: { u: '3', v: '4', w: '15' },
      7: { u: '4', v: '5', w: '6' },
      8: { u: '2', v: '4', w: '11' },
    },
  },
  {
    topNode: 20,
    topEdge: 35,
    isWeighted: true,
    isDirected: false,
    nodes: {
      0: {
        x: 58,
        y: 452,
      },
      1: {
        x: 94,
        y: 264,
      },
      2: {
        x: 253,
        y: 330,
      },
      3: {
        x: 322,
        y: 454,
      },
      4: {
        x: 381,
        y: 245,
      },
      5: {
        x: 140,
        y: 136,
      },
      6: {
        x: 499,
        y: 290,
      },
      7: {
        x: 528,
        y: 445,
      },
      8: {
        x: 443,
        y: 117,
      },
      9: {
        x: 284,
        y: 49,
      },
      10: {
        x: 558,
        y: 177,
      },
      11: {
        x: 580,
        y: 44,
      },
      12: {
        x: 702,
        y: 228,
      },
      13: {
        x: 670,
        y: 345,
      },
      15: {
        x: 752,
        y: 101,
      },
      16: {
        x: 841,
        y: 255,
      },
      17: {
        x: 845,
        y: 375,
      },
      18: {
        x: 721,
        y: 450,
      },
      19: {
        x: 868,
        y: 49,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '14',
      },
      1: {
        u: '1',
        v: '5',
        w: '9',
      },
      2: {
        u: '2',
        v: '1',
        w: '2',
      },
      3: {
        u: '2',
        v: '0',
        w: '9',
      },
      4: {
        u: '2',
        v: '3',
        w: '10',
      },
      5: {
        u: '0',
        v: '3',
        w: '7',
      },
      6: {
        u: '3',
        v: '4',
        w: '15',
      },
      7: {
        u: '4',
        v: '5',
        w: '6',
      },
      8: {
        u: '2',
        v: '4',
        w: '11',
      },
      9: {
        u: '3',
        v: '7',
        w: '2',
      },
      10: {
        u: '7',
        v: '6',
        w: '10',
      },
      11: {
        u: '6',
        v: '12',
        w: '2',
      },
      12: {
        u: '12',
        v: '13',
        w: '2',
      },
      13: {
        u: '13',
        v: '6',
        w: '5',
      },
      14: {
        u: '6',
        v: '8',
        w: '1',
      },
      15: {
        u: '8',
        v: '11',
        w: '23',
      },
      16: {
        u: '7',
        v: '13',
        w: '5',
      },
      17: {
        u: '12',
        v: '10',
        w: '7',
      },
      18: {
        u: '8',
        v: '9',
        w: '5',
      },
      19: {
        u: '9',
        v: '4',
        w: '6',
      },
      20: {
        u: '9',
        v: '5',
        w: '12',
      },
      21: {
        u: '9',
        v: '11',
        w: '2',
      },
      22: {
        u: '11',
        v: '10',
        w: '7',
      },
      23: {
        u: '6',
        v: '4',
        w: '1',
      },
      24: {
        u: '13',
        v: '18',
        w: '2',
      },
      25: {
        u: '18',
        v: '7',
        w: '1',
      },
      26: {
        u: '13',
        v: '17',
        w: '4',
      },
      27: {
        u: '12',
        v: '16',
        w: '20',
      },
      28: {
        u: '10',
        v: '15',
        w: '3',
      },
      29: {
        u: '15',
        v: '11',
        w: '1',
      },
      30: {
        u: '17',
        v: '18',
        w: '3',
      },
      31: {
        u: '17',
        v: '16',
        w: '2',
      },
      32: {
        u: '16',
        v: '15',
        w: '8',
      },
      33: {
        u: '19',
        v: '15',
        w: '10',
      },
      34: {
        u: '10',
        v: '8',
        w: '14',
      },
    },
  },
  {
    topNode: 5,
    topEdge: 8,
    isWeighted: true,
    isDirected: true,
    nodes: {
      0: {
        x: 150,
        y: 240,
      },
      1: {
        x: 327,
        y: 113,
      },
      2: {
        x: 329,
        y: 383,
      },
      3: {
        x: 644,
        y: 110,
      },
      4: {
        x: 645,
        y: 379,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '9',
      },
      1: {
        u: '0',
        v: '2',
        w: '3',
      },
      2: {
        u: '2',
        v: '1',
        w: '2',
      },
      3: {
        u: '1',
        v: '2',
        w: '6',
      },
      4: {
        u: '1',
        v: '3',
        w: '2',
      },
      5: {
        u: '2',
        v: '4',
        w: '1',
      },
      6: {
        u: '4',
        v: '2',
        w: '2',
      },
      7: {
        u: '4',
        v: '3',
        w: '2',
      },
    },
  },
  {
    topNode: 4,
    topEdge: 4,
    isWeighted: true,
    isDirected: true,
    nodes: {
      0: {
        x: 251,
        y: 139,
      },
      1: {
        x: 586,
        y: 142,
      },
      2: {
        x: 587,
        y: 400,
      },
      3: {
        x: 250,
        y: 399,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '1',
      },
      1: {
        u: '1',
        v: '2',
        w: '-1',
      },
      2: {
        u: '2',
        v: '3',
        w: '-1',
      },
      3: {
        u: '3',
        v: '0',
        w: '-1',
      },
    },
  },
  {
    topNode: 7,
    topEdge: 9,
    isWeighted: false,
    isDirected: true,
    nodes: {
      0: { x: 166, y: 314 },
      1: { x: 339, y: 248 },
      2: { x: 344, y: 398 },
      3: { x: 530, y: 384 },
      4: { x: 643, y: 334 },
      5: { x: 520, y: 226 },
      6: { x: 420, y: 107 },
    },
    edges: {
      0: { u: '0', v: '1', w: '1' },
      1: { u: '6', v: '1', w: '1' },
      2: { u: '6', v: '5', w: '1' },
      3: { u: '0', v: '2', w: '1' },
      4: { u: '1', v: '2', w: '1' },
      5: { u: '2', v: '3', w: '1' },
      6: { u: '5', v: '3', w: '1' },
      7: { u: '1', v: '5', w: '1' },
      8: { u: '5', v: '4', w: '1' },
    },
  },
  {
    topNode: 5,
    topEdge: 5,
    isWeighted: false,
    isDirected: true,
    nodes: {
      0: { x: 265, y: 245 },
      1: { x: 374, y: 149 },
      2: { x: 557, y: 203 },
      3: { x: 610, y: 331 },
      4: { x: 442, y: 384 },
    },
    edges: {
      0: { u: '0', v: '1', w: '1' },
      1: { u: '1', v: '2', w: '1' },
      2: { u: '2', v: '3', w: '1' },
      3: { u: '3', v: '4', w: '1' },
      4: { u: '4', v: '0', w: '1' },
    },
  },
  {
    nodes: {
      0: { x: 132, y: 65 },
      1: { x: 369, y: 158 },
      2: { x: 636, y: 72 },
      3: { x: 134, y: 268 },
      4: { x: 625, y: 270 },
      5: { x: 430, y: 385 },
      6: { x: 670, y: 426 },
    },
    topNode: 8,
    topEdge: 11,
    isWeighted: true,
    isDirected: false,
    edges: {
      0: { u: '0', v: '3', w: '5' },
      1: { u: '0', v: '1', w: '7' },
      2: { u: '3', v: '1', w: '9' },
      3: { u: '1', v: '2', w: '8' },
      4: { u: '2', v: '4', w: '5' },
      5: { u: '1', v: '4', w: '7' },
      6: { u: '3', v: '4', w: '15' },
      7: { u: '3', v: '5', w: '6' },
      8: { u: '5', v: '4', w: '8' },
      9: { u: '5', v: '6', w: '11' },
      10: { u: '4', v: '6', w: '9' },
    },
  },
  {
    topNode: 8,
    topEdge: 11,
    isWeighted: true,
    isDirected: false,
    nodes: {
      0: {
        x: 183,
        y: 111,
      },
      1: {
        x: 247,
        y: 228,
      },
      2: {
        x: 355,
        y: 64,
      },
      3: {
        x: 432,
        y: 178,
      },
      4: {
        x: 394,
        y: 310,
      },
      5: {
        x: 212,
        y: 395,
      },
      6: {
        x: 412,
        y: 456,
      },
      7: {
        x: 523,
        y: 371,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '2',
        w: '5',
      },
      1: {
        u: '0',
        v: '1',
        w: '3',
      },
      2: {
        u: '1',
        v: '3',
        w: '4',
      },
      3: {
        u: '2',
        v: '3',
        w: '12',
      },
      4: {
        u: '3',
        v: '4',
        w: '9',
      },
      5: {
        u: '3',
        v: '7',
        w: '8',
      },
      6: {
        u: '4',
        v: '5',
        w: '4',
      },
      7: {
        u: '4',
        v: '7',
        w: '1',
      },
      8: {
        u: '4',
        v: '6',
        w: '5',
      },
      9: {
        u: '5',
        v: '6',
        w: '6',
      },
      10: {
        u: '6',
        v: '7',
        w: '20',
      },
    },
  },
  {
    topNode: 10,
    topEdge: 21,
    isWeighted: true,
    isDirected: false,
    nodes: {
      0: {
        x: 41,
        y: 289,
      },
      1: {
        x: 159,
        y: 113,
      },
      2: {
        x: 190,
        y: 280,
      },
      3: {
        x: 267,
        y: 187,
      },
      4: {
        x: 404,
        y: 62,
      },
      5: {
        x: 555,
        y: 35,
      },
      6: {
        x: 545,
        y: 137,
      },
      7: {
        x: 743,
        y: 117,
      },
      8: {
        x: 436,
        y: 270,
      },
      9: {
        x: 419,
        y: 455,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '4',
      },
      1: {
        u: '1',
        v: '2',
        w: '4',
      },
      2: {
        u: '0',
        v: '2',
        w: '3',
      },
      3: {
        u: '1',
        v: '3',
        w: '2',
      },
      4: {
        u: '2',
        v: '3',
        w: '2',
      },
      5: {
        u: '1',
        v: '4',
        w: '9',
      },
      6: {
        u: '4',
        v: '5',
        w: '4',
      },
      7: {
        u: '5',
        v: '6',
        w: '1',
      },
      8: {
        u: '5',
        v: '7',
        w: '4',
      },
      9: {
        u: '6',
        v: '7',
        w: '3',
      },
      10: {
        u: '4',
        v: '6',
        w: '5',
      },
      11: {
        u: '3',
        v: '4',
        w: '9',
      },
      12: {
        u: '4',
        v: '8',
        w: '7',
      },
      13: {
        u: '3',
        v: '8',
        w: '8',
      },
      14: {
        u: '2',
        v: '8',
        w: '9',
      },
      15: {
        u: '0',
        v: '9',
        w: '9',
      },
      16: {
        u: '2',
        v: '9',
        w: '9',
      },
      17: {
        u: '9',
        v: '8',
        w: '8',
      },
      18: {
        u: '9',
        v: '7',
        w: '18',
      },
      19: {
        u: '8',
        v: '6',
        w: '9',
      },
      20: {
        u: '8',
        v: '7',
        w: '10',
      },
    },
  },
  {
    topNode: 6,
    topEdge: 10,
    isWeighted: true,
    isDirected: false,
    nodes: {
      0: {
        x: 152,
        y: 267,
      },
      1: {
        x: 258,
        y: 103,
      },
      2: {
        x: 609,
        y: 104,
      },
      3: {
        x: 424,
        y: 275,
      },
      4: {
        x: 424,
        y: 446,
      },
      5: {
        x: 670,
        y: 273,
      },
    },
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '3',
      },
      1: {
        u: '1',
        v: '2',
        w: '1',
      },
      2: {
        u: '1',
        v: '3',
        w: '4',
      },
      3: {
        u: '0',
        v: '3',
        w: '5',
      },
      4: {
        u: '0',
        v: '4',
        w: '6',
      },
      5: {
        u: '3',
        v: '4',
        w: '2',
      },
      6: {
        u: '3',
        v: '2',
        w: '4',
      },
      7: {
        u: '3',
        v: '5',
        w: '5',
      },
      8: {
        u: '5',
        v: '2',
        w: '6',
      },
      9: {
        u: '4',
        v: '5',
        w: '8',
      },
    },
  },
  {
    edges: {
      0: {
        u: '0',
        v: '1',
        w: '5',
      },
      1: {
        u: '1',
        v: '2',
        w: '2',
      },
      2: {
        u: '1',
        v: '3',
        w: '15',
      },
      3: {
        u: '2',
        v: '3',
        w: '2',
      },
      4: {
        u: '3',
        v: '4',
        w: '10',
      },
      5: {
        u: '4',
        v: '0',
        w: '16',
      },
      6: {
        u: '3',
        v: '5',
        w: '7',
      },
      7: {
        u: '5',
        v: '6',
        w: '10',
      },
      8: {
        u: '6',
        v: '7',
        w: '25',
      },
      9: {
        u: '6',
        v: '8',
        w: '11',
      },
      10: {
        u: '8',
        v: '9',
        w: '1',
      },
      11: {
        u: '7',
        v: '9',
        w: '4',
      },
      12: {
        u: '5',
        v: '10',
        w: '8',
      },
      13: {
        u: '10',
        v: '8',
        w: '18',
      },
      14: {
        u: '10',
        v: '11',
        w: '20',
      },
      15: {
        u: '11',
        v: '12',
        w: '25',
      },
      16: {
        u: '12',
        v: '13',
        w: '24',
      },
      17: {
        u: '12',
        v: '14',
        w: '12',
      },
      21: {
        u: '14',
        v: '9',
        w: '50',
      },
      22: {
        u: '14',
        v: '13',
        w: '50',
      },
    },
    topNode: 15,
    topEdge: 23,
    isWeighted: true,
    isDirected: false,
    nodes: {
      0: {
        x: 38,
        y: 394,
      },
      1: {
        x: 42,
        y: 162,
      },
      2: {
        x: 155,
        y: 271,
      },
      3: {
        x: 264,
        y: 164,
      },
      4: {
        x: 266,
        y: 396,
      },
      5: {
        x: 394,
        y: 166,
      },
      6: {
        x: 393,
        y: 253,
      },
      7: {
        x: 396,
        y: 396,
      },
      8: {
        x: 596,
        y: 311,
      },
      9: {
        x: 598,
        y: 395,
      },
      10: {
        x: 592,
        y: 167,
      },
      11: {
        x: 689,
        y: 168,
      },
      12: {
        x: 773,
        y: 167,
      },
      13: {
        x: 863,
        y: 167,
      },
      14: {
        x: 768,
        y: 396,
      },
    },
  },
];
